export default __webpack_public_path__ + "static/media/ctaDefaultIcon.81330fb1.svg";